import { Component, OnInit, HostBinding } from '@angular/core';
import { Router } from '@angular/router';
import { DataServiceService } from '../../../services/common/data-service.service';
import { PersistentStorageService } from '../../../services/common/persistent-storage.service';
import { LoaderService } from '../../../services/common/loader.service';
import { HeaderService } from '../../../services/common/header.service';
import { CommonService } from '../../../services/common/common.service';
import * as jwt_decode from 'jwt-decode';
import { USER_KEY, ACCESS_TO, STUDENT_DEGREE } from '../../../constants/user-constants';
import { EVENT, LOGTYPE } from '../../../constants/logging';

@Component({
	selector: 'app-listing',
	templateUrl: './listing.component.html',
	styleUrls: [ './listing.component.scss' ]
})
export class ListingComponent implements OnInit {
	@HostBinding('class') elementClass = 'app-listing';
	public inputData: string;
	public noResultFound = false;
	public showError = false;
	public isRecords = false;
	public showContinue = true;
	public controlListObject: any;
	public programDetails: any;
	public listType: string;
	public contentData: any;
	public studentData: any;
	public templateAllData: any;
	public selectedTemplateName = '';
	public currentUser = {
		email: null
	};

	public resourceData = {
		ADMIN_EDITOR_VIEW: {
			type: 'ADMIN_EDITOR_VIEW',
			mainHeading: 'Welcome to Admin/Edit View',
			inputLabel: 'Enter the email of the student',
			inputType: 'email',
			placeHolder: 'Enter the Email',
			errorMessage: 'Invalid Email Address',
			noDataMessage: 'No Student found'
		},
		ADMIN_READER_VIEW: {
			type: 'ADMIN_READER_VIEW',
			mainHeading: 'Welcome to Admin/Program View',
			inputLabel: 'Please choose template',
			inputType: 'text',
			placeHolder: '',
			errorMessage: 'Invalid template',
			noDataMessage: 'No template found'
		}
	};
	public tableContent = [];
	readerView = false;

	constructor(
		private readonly dataService: DataServiceService,
		private readonly router: Router,
		private readonly persistentStorageService: PersistentStorageService,
		private readonly loaderService: LoaderService,
		private readonly headerService: HeaderService,
		private readonly common: CommonService
	) {
		this.headerService.showStaffHeader();
	}

	ngOnInit() {
		this.loaderService.show();
		this.currentUser.email = this.persistentStorageService.getLocalStorage(USER_KEY.CURRENT_STAFF_EMAIL);
		const decodedAuthToken = jwt_decode(sessionStorage.getItem('auth_token'));
		this.common.addtoStack(this.currentUser.email, EVENT.AUTH_TOKEN_INFO, LOGTYPE.INFO, decodedAuthToken);
		// To get the group associated with the admin/staff
		const decodedToken = jwt_decode(sessionStorage.getItem('token'));
		let groups = decodedToken.Groups;
		if (groups === undefined || groups === null || groups.length === 0) {
			const errorBody = {
				groups,
				info: 'Unable to retrive groups informtaion from auth token.'
			};
			this.common.addtoStack(this.currentUser.email, EVENT.GROUP_ERROR, LOGTYPE.ERROR, errorBody);
			window.location.href = `${window.location.origin}/not-authorized.html`;
		}
		this.getAccessControl(groups);
		this.loaderService.hide();
		this.dataService.getAllTemplate().subscribe((templateData) => {
			this.templateAllData = templateData;
		});
	}

	/**
   * @description will retrive the role information
   * @param groupId (Array<string>)
   */
	private getAccessControl(groupIds: Array<string>) {
		this.dataService.getAccessControlDetails(groupIds).subscribe((accessControlDocs) => {
			// remove undefined elements
			accessControlDocs = accessControlDocs.filter((element) => element !== undefined);

			if (accessControlDocs.length === 1) {
				const accessControlData = accessControlDocs[0];
				// tslint:disable-next-line: no-string-literal
				const mainComponenObj = accessControlData['mainComponent'];

				if (!mainComponenObj.isAccess) {
					console.error('No Access');
					const errorBody = {
						groups: groupIds,
						data: accessControlData,
						info: `No Access to the main component`,
						suggestedIssue: [ 'mainComponent access is blocked in db.' ]
					};
					this.common.addtoStack(
						this.currentUser.email,
						EVENT.PERMISSION_DENIED_TO_MAIN_COMPONENT,
						LOGTYPE.ERROR,
						errorBody
					);
					window.location.href = `${window.location.origin}/not-authorized.html`;
				}

				this.dataService.getComponentsData(mainComponenObj._mainComponent_id).subscribe((componentDocRef) => {
					const componentData = componentDocRef.data();
					if (componentData) {
						// tslint:disable-next-line: no-string-literal
						if (componentData['mainComponent'] === ACCESS_TO.ADMIN_EDITOR) {
							this.listType = 'ADMIN_EDITOR_VIEW';
							this.readerView = false;
							const getCurrentStudent = localStorage.getItem(USER_KEY.CURRENT_STUDENT_EMAIL);
							if (getCurrentStudent) {
								this.fetchRecord(this.listType, getCurrentStudent);
							}
							// tslint:disable-next-line: no-string-literal
						} else if (componentData['mainComponent'] === ACCESS_TO.ADMIN_READER) {
							this.listType = 'ADMIN_READER_VIEW';
							this.readerView = true;
							const currentTemplateId = localStorage.getItem(USER_KEY.CURRENT_TEMPLATE_ID);
							if (currentTemplateId) {
								this.fetchRecord(this.listType, currentTemplateId);
							}
						} else {
							console.error('No mainControl Found');
							const errorBody = {
								info: `[${componentData['mainComponent']}] is not configured in db.`,
								suggestedIssue: [ 'Database config mismatch with app config.' ]
							};
							this.common.addtoStack(
								this.currentUser.email,
								EVENT.CONFIG_MISMATCH,
								LOGTYPE.ERROR,
								errorBody
							);
							window.location.href = `${window.location.origin}/not-authorized.html`;
						}
						this.contentData = this.resourceData[this.listType];
					} else {
						// no component data found
						const errorBody = {
							info: `[${mainComponenObj._mainComponent_id}] component not found in db.`,
							data: mainComponenObj,
							suggestedIssue: [ '_mainComponent_id is mismatched with comoponent doc id.' ]
						};
						this.common.addtoStack(
							this.currentUser.email,
							EVENT.COMPONENT_NOT_FOUND,
							LOGTYPE.ERROR,
							errorBody
						);
						window.location.href = `${window.location.origin}/not-authorized.html`;
					}
				});
			} else {
				const errorBody = {
					groups: groupIds,
					info: `[${accessControlDocs.length}] doc(s) matching with db but expecting [1]`,
					suggestedIssue: [
						'No group id is associated with the user.',
						'Group id is not active in db/firestore.',
						'More than one group matched with db.'
					]
				};
				this.common.addtoStack(this.currentUser.email, EVENT.GROUP_COUNT_ERROR, LOGTYPE.ERROR, errorBody);
				console.error(`${accessControlDocs.length} doc(s) found.`);
				window.location.href = `${window.location.origin}/not-authorized.html`;
			}
		});
	}

	private isRegistered(studentDoc: any) {
		if (!studentDoc) {
			return false;
		}
		return studentDoc.accepted_terms ? studentDoc.accepted_terms : false;
	}

	public viewStudent(studentEmail: string) {
		this.persistentStorageService.setLocalStorage(USER_KEY.CURRENT_STUDENT_EMAIL, studentEmail);
		this.router.navigate([ './student' ]);
	}

	public getEmailData(type: string, email: string) {
		if (type === 'ADMIN_EDITOR_VIEW') {
			if (!email) {
				this.noResultFound = false;
				this.showError = false;
			} else {
				if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
					this.showError = true;
					this.isRecords = false;
				} else {
					this.showError = false;
				}
			}
		} else {
			if (!email) {
				this.isRecords = false;
				this.showError = false;
				this.noResultFound = false;
			}
		}
	}

	public fetchRecord(type: string, inputContent: string) {
		const inputData = inputContent;
		if (inputData) {
			if (type === 'ADMIN_EDITOR_VIEW') {
				this.dataService.getSudentDocData(inputData.toLowerCase()).subscribe((studentData) => {
					this.studentData = studentData;
					if (studentData && studentData['isRegsiteredToCapstone']) {
						this.noResultFound = false;
						this.tableContent = [
							{ name: 'First Name', value: this.studentData.banner_data.studentFirstName },
							{ name: 'Last Name', value: this.studentData.banner_data.studentLastName },
							{ name: 'Email', value: this.studentData.upn },
							{ name: 'Banner ID', value: this.studentData.banner_data.studentID },
							{ name: 'ProgramCode', value: this.studentData.banner_data.ProgramCode },
							{ name: 'Program Description', value: this.studentData.banner_data.ProgramDescription },
							{ name: 'Status', value: this.checkStatus() }
						];
						if (this.tableContent) {
							this.isRecords = true;
						} else {
							this.isRecords = false;
						}
					} else {
						this.noResultFound = true;
						this.isRecords = false;
					}
				});
			} else {
				this.showTemplateInfo(inputData);
			}
		}
	}

	// set template information
	public showTemplateInfo(templateId: string) {
		if (templateId) {
			const templateInfo = this.templateAllData.find((template) => {
				return template.id === templateId;
			});
			this.persistentStorageService.setLocalStorage(USER_KEY.CURRENT_TEMPLATE_ID, templateId);
			this.noResultFound = false;

			this.tableContent = [
				{ name: 'Template Name', value: templateInfo.name },
				{ name: 'No of Phases', value: templateInfo.contentful_phase_ids.length },
				{ name: 'No of Programs', value: templateInfo.contentful_program_ids.length },
				{ name: 'isPublished', value: templateInfo.published }
			];
			if (this.tableContent) {
				this.isRecords = true;
			} else {
				this.isRecords = false;
			}
		} else {
			// template not found
			this.noResultFound = true;
			this.isRecords = false;
		}
	}

	public checkStatus() {
		let currentStatus: string;
		if (this.isRegistered(this.studentData)) {
			this.showContinue = true;
			currentStatus = STUDENT_DEGREE.PURSUING;
			if (this.studentData.isGraduated) {
				currentStatus = STUDENT_DEGREE.GRADUATED;
			}
		} else {
			currentStatus = STUDENT_DEGREE.NOT_YET_REGISTERED;
			this.showContinue = false;
		}
		return currentStatus;
	}

	public resetStudentTable() {
		this.inputData = '';
		this.isRecords = false;
		localStorage.removeItem(USER_KEY.CURRENT_STUDENT_EMAIL);
		localStorage.removeItem(USER_KEY.CURRENT_STAFF_EMAIL);
		localStorage.removeItem(USER_KEY.CURRENT_TEMPLATE_ID);
	}

	public navigateTo(type: string, inputData: string) {
		if (type === 'ADMIN_EDITOR_VIEW') {
			this.persistentStorageService.setLocalStorage(USER_KEY.CURRENT_STUDENT_EMAIL, this.studentData.upn);
			this.router.navigate([ 'student' ]);
		} else {
			this.router.navigate([ 'checklist' ]);
		}
	}
}
